import { Button } from "reactstrap";
import useModal from "../../../customHooks/useModal";
import useSWR from "swr";
import { customFetcher, getTsDate, notify } from "../../../utils";
import apiClient from "../../../apiClient";
import { useState } from "react";
import useUser from "../../../customHooks/useUser";
import { AircraftType, DelayCode } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import AircraftTypesModal from "./Modal";
import DelayCodesModal from "./Modal";
import ActionIcon from "../../../components/custom/ActionIcon";

const ENDPOINT = '/delay-code';

export default function DelayCodes() {

    const { data, mutate } = useSWR(ENDPOINT, customFetcher<DelayCode>, {
        fallbackData: []
    });

    const [id, setId] = useState<number>();
    const record = data.find(item => item.id === id);

    const createUpdateItem = async (data: DelayCode, update?: boolean) => {
        try {
            const method = update ? 'put' : 'post';
            await apiClient[method](ENDPOINT, data);
            mutate();
            setModal(false);
            notify('Success');
        } catch (err) {
            alert(err);
        }
    }

    const deleteItem = async (id: number) => {
        try {
            await apiClient.delete(`${ENDPOINT}/${id}`);
            setModal(false);
            notify('Deleted');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    const { modal, setModal } = useModal();

    const handleLaunchModal = (id?: number) => {
        setId(id || undefined);
        setModal(true);
    }

    return (
        <div>
            <ActionIcon
                type={'add'}
                onClick={handleLaunchModal}
            />            
            <VirtualTable<DelayCode>
                data={data}
                mapping={[{
                    name: 'Category',
                    value: 'category'
                }, {
                    name: 'Number',
                    value: 'number'
                }, {
                    name: 'Code',
                    value: 'code'
                }, {
                    name: 'Title',
                    value: 'title'
                }, {
                    name: 'Description',
                    value: 'description'
                }]}
                handleClick={item => handleLaunchModal(item.id)}
            />
            <DelayCodesModal
                modal={modal}
                setModal={setModal}
                onSubmit={createUpdateItem}
                deleteItem={deleteItem}
                record={record}
            />
        </div>
    );
}